import { dbFetch } from 'store/actions';
import schemas from 'schemas';

const dispatchQuery = (dispatch, query, objectNameResult, schemaName) => {
  schemaName = schemaName || objectNameResult;
  const schemaObject = Object.assign({}, schemas, {
    [objectNameResult]: schemas[schemaName]
  })
  dispatch(dbFetch(query, schemaObject));
}

export default dispatchQuery;



// WEBPACK FOOTER //
// ./src/helpers/dispatchQuery.jsx